import { render } from "./Huwai.vue?vue&type=template&id=24720822&scoped=true"
import script from "./Huwai.vue?vue&type=script&lang=js"
export * from "./Huwai.vue?vue&type=script&lang=js"

import "./Huwai.vue?vue&type=style&index=0&id=24720822&lang=scss&scoped=true"

import exportComponent from "E:\\Old Files\\Projecten Web\\Q-Mobile\\frame\\q-mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24720822"]])

export default __exports__